import type { SelectedAddress } from '../../helpers/AddressValidationContext';

export const extractStreetNumber = (address: SelectedAddress | null) => {
  const regex = /\b\d+[A-Za-z]*(?:-\d+[A-Za-z]*)?\b/;
  const matches = address?.street1?.match(regex);
  return matches ? matches[0] : null;
};

export const addressNotFound = (errorData: string | { message: string }) => {
  const msg = typeof errorData === 'string' ? errorData : errorData.message;
  return msg.indexOf('NOT_FOUND') === 2;
};
